import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'languageSelected',
  pure: false,
  standalone: false,
})
export class LanguageSelectionPipe implements PipeTransform {
  transform(localeCode: string): string {
    const url = new URL(window.location.href);
    const pathParts = url.pathname.split('/');
    if (pathParts.length > 1) {
      pathParts[1] = localeCode;
    } else {
      pathParts.push(localeCode);
    }

    const newPathname = pathParts.join('/');
    return `${newPathname}${url.search}`;
  }
}
